import React, { useState, useEffect } from 'react';
import { productImg } from '../../lib/constants';
import { Button, Form, Grid, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import { useError } from "../../state/error";
import Select from 'react-select'

const initializeData = () => {
  return {
    productUrl: null,
    name: '',
    category: null,
    subcategory: null,
    price: '',
    picture: null,
    quantity: 1,
    weight: 0,
    details: 'no details'
  }
}

const ShipmentCreateAddProduct = ({ products, saveProduct, deleteProduct, editProduct }) => {
  const { setIsError } = useError();
  const [form, changeFormInput] = useState(initializeData());

  const { data: product, loading: productLoading } = useFetch(`products/scrap/${form.productUrl}`);
  const [currentProduct, setCurrentProduct] = useState({ label: `Product ${products.length + 1}`, value: initializeData() })

  useEffect(() => {
    if (products.length > 0) {
      setCurrentProduct({ label: `Product ${products.length + 1}`, value: initializeData() })
      changeFormInput(initializeData())
    }
  }, [products])

  useEffect(() => {
    product && product.name && changeFormInput({
      ...form,
      name: product.name,
      picture: product.picture === 'Cant Crawel Image' ? null : product.picture,
      price: product.price
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);

  const { data: categories, loading: categoriesLoading } = useFetch(`categories`);
  const { data: subCategories, loading: subCategoriesLoading } = useFetch(`categories/${form.category && form.category.value}/sub-category`);

  const addProduct = () => {
    if (!form.subcategory || !form.productUrl) {
      setIsError("Please fill all fields")
      return
    }
    
    saveProduct(form)
  }

  return (
    <Grid>
      <Grid.Row>
        <Grid.Col width={4}>
          <Form.Label>Product Number</Form.Label>
          <Select
            value={currentProduct}
            options={(products || []).map((p, i) => ({ label: `Product ${i + 1}`, value: p })).concat({ label: `Product ${((products || []).length + 1)}`, value: initializeData() })}
            onChange={(e) => {
              setCurrentProduct(e)
              changeFormInput(e.value)
            }}
          />

          <Form.Label>picture</Form.Label>
          <Dimmer
            active={!!form.productUrl && !!productLoading}
            loader={!!form.productUrl && !!productLoading}
          >
            <div style={{ textAlign: 'center' }} className="mb-1">
              <img
                alt=""
                src={form.picture || productImg}
                style={{ maxHeight: '220px', margin: '0 auto' }}
              />
            </div>
          </Dimmer>
        </Grid.Col>
        <Grid.Col width={8}>
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Col width={12}>
                  <Form.Input
                    icon={!!form.productUrl && !!productLoading ? "loader" : "search"}
                    position="append"
                    label="Link"
                    value={form.productUrl || ''}
                    type="text"
                    name="productUrl"
                    placeholder="product url"
                    onChange={(e) => changeFormInput({
                      ...form,
                      productUrl: encodeURIComponent(e.target.value)
                    })}
                  />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Label>Category</Form.Label>
                  <Select
                    value={form.category}
                    options={(categories || []).map(cat => {
                      return ({ label: cat.name, value: cat['_id'] });
                    })}
                    placeholder="Category"
                    isLoading={categoriesLoading}
                    onChange={(e) => {
                      changeFormInput({
                        ...form,
                        category: e
                      })
                    }}
                  />
                  <br />
                  <Form.Input
                    label="Price"
                    icon={!!form.productUrl && !!productLoading ? "loader" : ""}
                    position="append"
                    value={form.price}
                    type="text"
                    name="price"
                    placeholder="price"
                    onChange={(e) => changeFormInput({
                      ...form,
                      price: e.target.value
                    })}
                  />
                  <Form.Input
                    label="Quantity"
                    value={form.quantity}
                    type="number"
                    name="quantity"
                    placeholder="quantity"
                    onChange={(e) => changeFormInput({ ...form, quantity: e.target.value })}
                  />
                  <Form.Textarea
                    label="Details"
                    value={form.details}
                    type="text"
                    name="product_details"
                    placeholder="Product details and notes"
                    onChange={(e) => changeFormInput({
                      ...form,
                      details: e.target.value
                    })}
                  />

                </Grid.Col>
                <Grid.Col width={6}>
                  <Form.Label>Sub Category:</Form.Label>
                  <Select
                    value={form.subcategory}
                    options={(subCategories || []).map(sub => {
                      return ({ label: sub.name, value: sub['_id'] });
                    })}
                    placeholder="sub category"
                    isLoading={subCategoriesLoading}
                    onChange={(e) => {
                      changeFormInput({
                        ...form,
                        subcategory: e
                      })
                    }}
                  />
                  <br />
                  <Form.Input
                    label="Name"
                    icon={!!form.productUrl && !!productLoading ? "loader" : ""}
                    position="append"
                    value={form.name}
                    type="text"
                    name="name"
                    placeholder="name"
                    onChange={(e) => changeFormInput({
                      ...form,
                      name: e.target.value
                    })}
                  />
                  <Form.Input
                    label="Weight"
                    value={form.weight}
                    type="text"
                    name="weight"
                    placeholder="weight"
                    onChange={(e) => changeFormInput({
                      ...form,
                      weight: e.target.value
                    })}
                  />
                </Grid.Col>
              </Grid.Row>
            </Grid>
          </Form>
        </Grid.Col>
      </Grid.Row>

      {currentProduct.value.productUrl ?
        <div className="text-right">
          <Button
            color="primary"
            size="sm"
            onClick={() => editProduct(currentProduct.label.split('Product ')[1] - 1, form)}
          >
            Edit
          </Button>

          <Button
            color="danger"
            size="sm"
            className="ml-2"
            onClick={() => deleteProduct(currentProduct.label.split('Product ')[1] - 1)}
          >
            Delete
          </Button>
        </div>
        :
        <Button
          color="primary"
          size="sm"
          className="ml-auto d-block"
          onClick={addProduct}
        >
          Add
        </Button>
      }
    </Grid>
  );
}
export default ShipmentCreateAddProduct;